module.exports = __webpack_public_path__ + "media/images/mobile/home/list_b-447b18eb055209c27ae82b65c60aac3c.png";